import React from 'react'
import injectSheet from 'react-jss'
import styles from './unsplash.styles'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import Preview from './preview/preview'
import { useState } from 'react'

const Unsplash = ({
  classes,
  onSearchChange,
  defaultSearchValue,
  id,
  pending,
  previews,
  onUnsplashSelect
}) => {
  const [value, setValue] = useState(defaultSearchValue)

  return (
    <div>
      <FormLabel small htmlFor="unsplashSearch">
        Search for an image
      </FormLabel>
      <FormInput
        clearable
        autoFocus={true}
        value={value}
        className={classes.searchInput}
        id="unsplashSearch"
        placeholder="e.g. Roman empire"
        onChange={e => {
          const value = e.target.value
          setValue(value)
          onSearchChange(value)
        }}
      />
      <p className={classes.unsplashMessage}>
        Photos by{' '}
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://unsplash.com?utm_source=pobble&utm_medium=referral">
          Unsplash
        </a>
      </p>
      <Preview
        id={id}
        pending={pending}
        previews={previews}
        onUnsplashSelect={onUnsplashSelect}
      />
    </div>
  )
}

export default injectSheet(styles)(Unsplash)
